import { TimedEvent } from '@opentelemetry/api';
import { flatbuffers } from 'flatbuffers';
import { TraceFB } from './Protocol/EndeavourProtocol';
import { ProtocolUtils } from './ProtocolUtils';
import { ReadableSpan } from './Span';

export class SpanModel {
  public buildFbSpan(builder: flatbuffers.Builder, span: ReadableSpan): Number {
    let parentSpanId: string = '';

    const traceIdBuffer = ProtocolUtils.hexIdToBuf(span.spanContext.traceId);
    const traceId = TraceFB.Span.createTraceIdVector(builder, traceIdBuffer);

    const spanIdBuffer = ProtocolUtils.hexIdToBuf(span.spanContext.spanId);
    const spanId = TraceFB.Span.createSpanIdVector(builder, spanIdBuffer);

    if (span.parentSpanId !== undefined) {
      parentSpanId = span.parentSpanId;
    }

    const parentTraceIdBuffer = ProtocolUtils.hexIdToBuf(parentSpanId);
    const parentSpanIdVector = TraceFB.Span.createParentSpanIdVector(builder, parentTraceIdBuffer);

    let traceState = builder.createString('DEFAULT_STATE');
    const name = builder.createString(span.name);

    const eventIndexes: number[] = [];
    for (const event of span.events) {
      eventIndexes.push(SpanModel.buildFbEvent(builder, event));
    }
    const eventVectorOffset = TraceFB.Span.createEventsVector(builder, eventIndexes);

    // TODO: Implement Standard Attribute Support
    const customAttributeIndexes = ProtocolUtils.createCustomAttributeIndexes(builder, span.attributes);
    const customAttributesVectorOffset = TraceFB.Span.createCustomAttributesVector(builder, customAttributeIndexes);

    const startTimeStamp = ProtocolUtils.buildTimeStamp(span.startTime);
    const endTimeStamp = ProtocolUtils.buildTimeStamp(span.endTime);

    const statusCode: number = span.status.code.valueOf();
    const statusMessage: flatbuffers.Offset = builder.createString(span.status.message || '');

    // Create Span
    TraceFB.Status.createStatus(builder, statusCode, statusMessage);
    TraceFB.Span.startSpan(builder);
    TraceFB.Span.addTraceId(builder, traceId);
    TraceFB.Span.addSpanId(builder, spanId);
    TraceFB.Span.addTraceState(builder, traceState);
    TraceFB.Span.addParentSpanId(builder, parentSpanIdVector);
    TraceFB.Span.addName(builder, name);
    TraceFB.Span.addKind(builder, TraceFB.SpanKind.SPAN_KIND_CLIENT);
    TraceFB.Span.addEvents(builder, eventVectorOffset);
    TraceFB.Span.addCustomAttributes(builder, customAttributesVectorOffset);
    TraceFB.Span.addStartTimeUnixNano(builder, startTimeStamp);
    TraceFB.Span.addEndTimeUnixNano(builder, endTimeStamp);
    return TraceFB.Span.endSpan(builder);
  }

  private static buildFbEvent(builder: flatbuffers.Builder, event: TimedEvent): number {
    const name = builder.createString(event.name);

    // TODO: Implement Standard Attribute Support
    const standardAttributeIndexes: Array<flatbuffers.Offset> = [];
    const standardAttributesVectorOffset = TraceFB.Event.createStandardAttributesVector(builder, standardAttributeIndexes);

    const customAttributeIndexes = ProtocolUtils.createCustomAttributeIndexes(builder, event.attributes);
    const customAttributesVectorOffset = TraceFB.Event.createCustomAttributesVector(builder, customAttributeIndexes);

    return TraceFB.Event.createEvent(
      builder,
      ProtocolUtils.numberToLong(Number(event.time[0] + '' + event.time[1])),
      name,
      customAttributesVectorOffset,
      standardAttributesVectorOffset,
      0
    );
  }
}
